import React, { forwardRef, useContext } from 'react';
import { ChildDataDropdownSetAddresses } from './ChildDataDropdownSetAddresses';
import { ChildDataTextSetAddresses } from './ChildDataTextSetAddresses';
import { ChildDataAutomaticSetAddresses } from './ChildDataAutomaticSetAddresses';
import { ParameterContext } from '../contexts/ParameterContext';
import { AddressContext } from '../contexts/AddressContext';
import { AuthContext } from '../contexts/AuthContext';


const ChildrenData = forwardRef(({ formData, handleChange, addTwin, removeTwin, isDropdownOpen, toggleDropDown, onBlurValidate, errors, onBlurTwins, isEdit, isMunicipality }, ref) => {
    const { addressResidence} = useContext(AddressContext);
    const { parameters } = useContext(ParameterContext);
    const { user } = useContext(AuthContext);

    const mainRegForm = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'MAIN_REGISTER_FORM');
    const dirDisableChildData = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');
    //const autoTimeLived = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'AUTOMATIC_TIME_LIVED');
    const dirRegisterForm = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'DIRECTOR_REGISTER_FORM');

    if (user.role == 'Director') {
        if (dirRegisterForm.value == 1) {
            return <ChildDataDropdownSetAddresses
                formData={formData}
                handleChange={handleChange}
                isEdit={isEdit}
                onBlurValidate={onBlurValidate}
                errors={errors}
                isDropdownOpen={isDropdownOpen}
                toggleDropDown={toggleDropDown}
                onBlurTwins={onBlurTwins}
                addTwin={addTwin}
                removeTwin={removeTwin}
                ref={ref }
            />
        } else if (dirRegisterForm.value == 2) {
            return <ChildDataTextSetAddresses
                formData={formData}
                handleChange={handleChange}
                isEdit={isEdit}
                onBlurValidate={onBlurValidate}
                errors={errors}
                isDropdownOpen={isDropdownOpen}
                toggleDropDown={toggleDropDown}
                onBlurTwins={onBlurTwins}
                addTwin={addTwin}
                removeTwin={removeTwin}
                ref={ ref}
            />
        } else if (dirRegisterForm.value == 0 || (dirDisableChildData.value == 1 && addressResidence.length > 0)) {
            return <ChildDataAutomaticSetAddresses
                formData={formData}
                handleChange={handleChange}
                isEdit={isEdit}
                onBlurValidate={onBlurValidate}
                errors={errors}
                onBlurTwins={onBlurTwins}
                addTwin={addTwin}
                removeTwin={removeTwin}
                ref={ref }
            />
        }
    }


    if (user.changeGrao == 0) {
        return <ChildDataAutomaticSetAddresses
            formData={formData}
            handleChange={handleChange}
            isEdit={isEdit}
            onBlurValidate={onBlurValidate}
            errors={errors}
            onBlurTwins={onBlurTwins}
            addTwin={addTwin}
            removeTwin={removeTwin}
            ref={ref}
        />
    } else if (user.role === "Municipality" || isMunicipality || (user.changeGrao == 1 && user.role != 'Parent')) {
        return <ChildDataTextSetAddresses
            formData={formData}
            handleChange={handleChange}
            isEdit={isEdit}
            onBlurValidate={onBlurValidate}
            errors={errors}
            isDropdownOpen={isDropdownOpen}
            toggleDropDown={toggleDropDown}
            onBlurTwins={onBlurTwins}
            addTwin={addTwin}
            removeTwin={removeTwin}
            ref={ref}
        />
    } else if (mainRegForm.value == 1) {
        return <ChildDataDropdownSetAddresses
            formData={formData}
            handleChange={handleChange}
            isEdit={isEdit}
            onBlurValidate={onBlurValidate}
            errors={errors}
            isDropdownOpen={isDropdownOpen}
            toggleDropDown={toggleDropDown}
            onBlurTwins={onBlurTwins}
            addTwin={addTwin}
            removeTwin={removeTwin}
            ref={ref}
        />
    } else {
        return <ChildDataAutomaticSetAddresses
            formData={formData}
            handleChange={handleChange}
            isEdit={isEdit}
            onBlurValidate={onBlurValidate}
            errors={errors}
            onBlurTwins={onBlurTwins}
            addTwin={addTwin}
            removeTwin={removeTwin}
            ref={ref}
        />
    }

})

export default ChildrenData;
